module.exports = __webpack_public_path__ + "img/database.3655c033.svg";